/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseCVClosedIcon16Light } from './ArrowCollapseCVClosedIcon16Light';
import { ArrowCollapseCVClosedIcon16Regular } from './ArrowCollapseCVClosedIcon16Regular';
import { ArrowCollapseCVClosedIcon16Solid } from './ArrowCollapseCVClosedIcon16Solid';
import { ArrowCollapseCVClosedIcon20Light } from './ArrowCollapseCVClosedIcon20Light';
import { ArrowCollapseCVClosedIcon20Regular } from './ArrowCollapseCVClosedIcon20Regular';
import { ArrowCollapseCVClosedIcon20Solid } from './ArrowCollapseCVClosedIcon20Solid';
import { ArrowCollapseCVClosedIcon24Regular } from './ArrowCollapseCVClosedIcon24Regular';
import { ArrowCollapseCVClosedIcon24Solid } from './ArrowCollapseCVClosedIcon24Solid';
import { ArrowCollapseCVClosedIcon32Regular } from './ArrowCollapseCVClosedIcon32Regular';
import { ArrowCollapseCVClosedIcon64Regular } from './ArrowCollapseCVClosedIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseCVClosedIcon16Light,
        regular: ArrowCollapseCVClosedIcon16Regular,
        solid: ArrowCollapseCVClosedIcon16Solid,
    },
    20: {
        light: ArrowCollapseCVClosedIcon20Light,
        regular: ArrowCollapseCVClosedIcon20Regular,
        solid: ArrowCollapseCVClosedIcon20Solid,
    },
    24: {
        regular: ArrowCollapseCVClosedIcon24Regular,
        solid: ArrowCollapseCVClosedIcon24Solid,
    },
    32: {
        regular: ArrowCollapseCVClosedIcon32Regular,
    },
    64: {
        regular: ArrowCollapseCVClosedIcon64Regular,
    },
};
export var ArrowCollapseCVClosedIcon = forwardRef('ArrowCollapseCVClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
